import type { User } from '@microsoft/microsoft-graph-types';
import { defineStore } from 'pinia'
import avatarPlaceholder from '~/assets/images/avatar-placeholder.png';
import type { UserProfileImage } from '~/constants/types/UserProfileImage';

export const useUserStore = defineStore('user-store', () => {
  /** States */
  const _user = ref<User | null>(null);
  const _userImage = ref<UserProfileImage | null>(null);
  const _userInitials = ref<string | null>(null);

  /** Getters */
  const user = computed<User | null>(() => _user.value);
  const userImageUrl = computed<string>(() => _userImage.value?.data ?? avatarPlaceholder);
  const userInitials = computed(() => _userInitials.value);

  /** Actions */
  function setUser(user: User | null) {
    _user.value = user;
  }

  function setUserImage(userImage: UserProfileImage | null) {
    _userImage.value = userImage;
  }

  function setUserInitials(userInitials: string | null) {
    _userInitials.value = userInitials;
  }

  function reset() {
    _user.value = null;
    _userImage.value = null;
    _userInitials.value = null;
  }

  return {
    user,
    userImageUrl,
    userInitials,

    setUser,
    setUserImage,
    setUserInitials,
    reset,
  }
});
